const $ = jQuery.noConflict();

class ScrollDownHero {
    constructor(heroScrollBtn, hero='.page-hero') {
        this.heroScrollBtn = heroScrollBtn;
        this.hero = hero;
    }
    init() {
        this.setScrollBtnPos();
        $(this.heroScrollBtn).on('click', this.scrollDownHeader);
    }
    scrollDownHeader(e) {
        const hero = $(e.currentTarget).closest('.page-hero');
        const heroHeight = hero.outerHeight();
        const headerHeight = $('.main-header').outerHeight();

        $('html, body').animate({
            scrollTop: heroHeight - headerHeight
        }, 400);
    }
    setScrollBtnPos() {
        const scrollTop = $(window).scrollTop();
        const windowHeight = $(window).height();
        const scrollHeight = scrollTop + windowHeight;
        const heroHeight = $(this.hero).outerHeight();

        if(heroHeight > scrollHeight) {
            $(this.heroScrollBtn).css({
                "position": "fixed"
            });
        }
        else {
            $(this.heroScrollBtn).css({
                "position": "absolute"
            });
        }
    }
}

const scrollDownHero = new ScrollDownHero('.hero-scroll-down', '.page-hero');
export default scrollDownHero;